<template>
    <div class="bx_top">
        <strong class="top_point green"><a href="#">{{writer}}</a></strong>
        <div class="title_area">
            <h2 class="tit_cont">{{title}}</h2>
            <div class="date">{{sendDateText}}</div>
        </div>
    </div>
</template>

<script>
    import {toResponseViewFormat} from "@/common/utils/date.js";

    export default {
        name: "ResponseTitle",

        props: {
            alertText: {
            },

            periodText: {
            },

            title: {
                type: String,
                required: true
            },

            writer: {
                type: String,
                required: true
            },

            sendDateString: {
                type: String,
                required: true
            }
        },

        computed: {
            sendDateText() {
                return toResponseViewFormat(this.sendDateString);
            }
        }
    }
</script>

<style scoped>

</style>